"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Address = void 0;
/**
 * This entity represents an Address
 */
class Address {
    constructor(json) {
        Object.assign(this, json);
    }
}
exports.Address = Address;
(function (Address) {
    Address.AddressTypeEnum = {
        Home: 'home',
        Work: 'work',
        Vacation: 'vacation',
        Hospital: 'hospital',
        Clinic: 'clinic',
        Hq: 'hq',
        Other: 'other',
        Temporary: 'temporary',
        Postal: 'postal',
        Diplomatic: 'diplomatic',
        Reference: 'reference',
    };
})(Address = exports.Address || (exports.Address = {}));
//# sourceMappingURL=Address.js.map